module.exports = __webpack_public_path__ + "img/two-doctors.e8543a5b.svg";